import { buildURL } from './route-utils';
import type { Query } from '../type/query.d';
import type { URLResponse } from '../type/urlResponse.d';

export const handleLangURLs = (path = '/', query: Query = {}): URLResponse => {
  let englishLink = null;
  let spanishLink = null;

  const queryObj = query;

  if (Object.keys(query).length === 0) {
    if (typeof window !== 'undefined') {
      const { searchParams } = new URL(window.location.href);
      searchParams.forEach((value, key) => {
        queryObj[key] = value;
      });
    }
  }

  const splitPath = path.split('/').filter((part) => part) || [];

  if (splitPath[0] === 'es') {
    splitPath.shift();
    englishLink = {
      url: buildURL(`/${splitPath.join('/')}`, queryObj),
      text: '',
    };
  } else {
    splitPath.unshift('es');
    spanishLink = {
      url: buildURL(`/${splitPath.join('/')}`, queryObj),
      text: '',
    };
  }

  const links = { englishLink, spanishLink };

  return links;
};
